import { Helmet } from 'react-helmet-async';
import { FaqsView } from 'src/sections/faqs/view';

// ----------------------------------------------------------------------

export default function FAQPage() {
  return (
    <>
      <Helmet>
        <title> FAQ: FAQ Page</title>
      </Helmet>

      <FaqsView />
    </>
  );
}
